import { useHistory, useLocation } from 'react-router';

import { Sidebar } from 'CorePackage/MainModule/components/Sidebar';

import styles from './ControlPanel.module.scss';
import { IMenuItem } from '../interfaces/IMenuItem';

interface IControlPanelProps {
  menuItems: IMenuItem[];
  header?: JSX.Element;
}

export const ControlPanel = ({ menuItems, header }: IControlPanelProps) => {
  const history = useHistory();
  const location = useLocation();

  const renderData = () => menuItems?.find(x => x.route === location.pathname)?.component;
  const redirectToInitialRoute = () => history.push(menuItems[0].route);

  return (
    <div className={styles.Wrapper}>
      <div className={styles.Header}>{header || null}</div>
      <div className={styles.Main}>
        <Sidebar
          type="control-panel"
          menuItems={menuItems?.map(item => ({
            route: item.route,
            title: item.title,
            versionAvailable: item.versionAvailable,
          }))}
        />
        <div className={styles.DataSection}>{renderData() || redirectToInitialRoute() || null}</div>
      </div>
    </div>
  );
};
